<button mat-list-item class="list-item-button" [attr.data-testid]="testId() + '-button' || null" [class.active]="active()" (click)="clicked.emit()">
  @if (showCheckbox()) {
    <mat-checkbox
      color="primary"
      [checked]="checked()"
      [attr.data-testid]="testId() ? testId() + '-checkbox' : null"
      (click)="$event.stopPropagation()"
      (change)="checkedChange.emit($event.checked)"
    ></mat-checkbox>
  } @else if (icon()) {
    <fa-icon [icon]="icon()"></fa-icon>
  }

  {{ text() | toPlainText }}
</button>
